import { render } from "./Linkedin.vue?vue&type=template&id=1f378db0"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__